// source: pbtypes/gen/cellular_sim_configs/fn980_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_band_pb = require('../../../pbtypes/gen/cellular_sim_configs/band_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_band_pb);
var pbtypes_gen_cellular_sim_configs_sim_config_override_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_config_override_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_config_override_pb);
goog.exportSymbol('proto.cellular_sim_configs.Fn980Config', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.Fn980Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cellular_sim_configs.Fn980Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.Fn980Config.displayName = 'proto.cellular_sim_configs.Fn980Config';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.Fn980Config.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.Fn980Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.Fn980Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Fn980Config.toObject = function(includeInstance, msg) {
  var f, obj = {
fwswitch: jspb.Message.getFieldWithDefault(msg, 1, 0),
bandOverride: (f = msg.getBandOverride()) && pbtypes_gen_cellular_sim_configs_band_pb.Band.toObject(includeInstance, f),
bandOverrideSet: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
override: (f = msg.getOverride()) && pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.Fn980Config}
 */
proto.cellular_sim_configs.Fn980Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.Fn980Config;
  return proto.cellular_sim_configs.Fn980Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.Fn980Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.Fn980Config}
 */
proto.cellular_sim_configs.Fn980Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFwswitch(value);
      break;
    case 2:
      var value = new pbtypes_gen_cellular_sim_configs_band_pb.Band;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_band_pb.Band.deserializeBinaryFromReader);
      msg.setBandOverride(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBandOverrideSet(value);
      break;
    case 4:
      var value = new pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.deserializeBinaryFromReader);
      msg.setOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.Fn980Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.Fn980Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.Fn980Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Fn980Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFwswitch();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getBandOverride();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_cellular_sim_configs_band_pb.Band.serializeBinaryToWriter
    );
  }
  f = message.getBandOverrideSet();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOverride();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 fwswitch = 1;
 * @return {number}
 */
proto.cellular_sim_configs.Fn980Config.prototype.getFwswitch = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
 */
proto.cellular_sim_configs.Fn980Config.prototype.setFwswitch = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Band band_override = 2;
 * @return {?proto.cellular_sim_configs.Band}
 */
proto.cellular_sim_configs.Fn980Config.prototype.getBandOverride = function() {
  return /** @type{?proto.cellular_sim_configs.Band} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_band_pb.Band, 2));
};


/**
 * @param {?proto.cellular_sim_configs.Band|undefined} value
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
*/
proto.cellular_sim_configs.Fn980Config.prototype.setBandOverride = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
 */
proto.cellular_sim_configs.Fn980Config.prototype.clearBandOverride = function() {
  return this.setBandOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.Fn980Config.prototype.hasBandOverride = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool band_override_set = 3;
 * @return {boolean}
 */
proto.cellular_sim_configs.Fn980Config.prototype.getBandOverrideSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
 */
proto.cellular_sim_configs.Fn980Config.prototype.setBandOverrideSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional SimConfigOverride override = 4;
 * @return {?proto.cellular_sim_configs.SimConfigOverride}
 */
proto.cellular_sim_configs.Fn980Config.prototype.getOverride = function() {
  return /** @type{?proto.cellular_sim_configs.SimConfigOverride} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride, 4));
};


/**
 * @param {?proto.cellular_sim_configs.SimConfigOverride|undefined} value
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
*/
proto.cellular_sim_configs.Fn980Config.prototype.setOverride = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.Fn980Config} returns this
 */
proto.cellular_sim_configs.Fn980Config.prototype.clearOverride = function() {
  return this.setOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.Fn980Config.prototype.hasOverride = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.cellular_sim_configs);
